import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { styled } from 'styled-components';
import { Entity } from '@debbie/common/dist/index.js';
import { c } from '@debbie/cortex/dist/index.js';
import * as proceduresLib from '@debbie/cortex/dist/api/procedures.js';
import { selectCaseById } from '@debbie/cortex/dist/cases/selectors.js';
import { selectCaseProcedures } from '@debbie/cortex/dist/procedures/selectors.js';
import { PlaceholderLoader } from '..//index.js';
import THEME from '../../theme.js';
import { Row, Col } from '../Grid/index.js';
import Codepen from '../Icons/Codepen.js';
import q from '@debbie/cortex/dist/query.js';
import { interactionsByReferenceKey } from '@debbie/cortex/dist/interactions/index.js';
const ProcedureStyled = styled.div `
  margin-bottom: ${THEME.GRID_SPACING}px;
  box-shadow: 0 20px 20px -30px rgba(0, 0, 0, 0.7);
  border-radius: 3px;
  background-color: lightgrey;
  border: 1px solid lightgrey;
  transform: translateY(0px);
  transition: transform 0.2s;
  cursor: pointer;
  overflow: hidden;

  &:hover {
    transform: translateY(-3px);
  }

  &::after {
    content: '';
    clear: both;
    display: table;
  }

  p,
  h3 {
    font-size: 0.8em;
    margin-top: 0.2em;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    margin-bottom: 0.3em;
  }

  .procedure-content,
  .procedure-icon {
    float: left;
    padding: 8px 12px;
  }

  .procedure-icon {
    width: 50px;

    svg {
      height: 20px;
      width: 20px;
      margin: 10px auto;
      display: block;
    }
  }

  .procedure-content {
    width: calc(100% - 50px);
    background-color: ${THEME.COLOR_SECONDARY};
    border-top-left-radius: 3px;
    border-bottom-left-radius: 3px;
  }
`;
const Procedures = (props) => {
    const lang = useSelector((s) => s.lang);
    const { caseId, caseCreditorId, caseCollectorId, tenantId } = props;
    const [proceduresRunning, setProceduresRunning] = useState({});
    const proceduresList = useSelector((s) => selectCaseProcedures(s, caseCreditorId, tenantId, caseCollectorId));
    const singleCase = useSelector((s) => selectCaseById(s, caseId));
    const runProcedure = async (procedure) => {
        if (confirm(lang.interactions.areYouSureProcedure)) {
            if (!proceduresRunning[procedure.procedureId]) {
                setProceduresRunning({
                    ...proceduresRunning,
                    [procedure.procedureId]: true,
                });
                try {
                    await proceduresLib.run(procedure.procedureId, props.caseId);
                    await c.cases.getById(caseId);
                    if (singleCase) {
                        q.invalidate([
                            interactionsByReferenceKey(Entity.Case, singleCase.caseId),
                        ]);
                    }
                    setProceduresRunning({
                        ...proceduresRunning,
                        [procedure.procedureId]: false,
                    });
                }
                catch (err) {
                    setProceduresRunning({
                        ...proceduresRunning,
                        [procedure.procedureId]: false,
                    });
                }
            }
        }
    };
    return (React.createElement(Row, null, proceduresList.map((procedure) => (React.createElement(Col, { width: "6", key: procedure.procedureId },
        React.createElement(ProcedureStyled, { style: {
                opacity: proceduresRunning[procedure.procedureId] ? 0.7 : 1,
            }, "data-tooltip-id": "tooltip-default", "data-tooltip-content": procedure.description, onClick: () => runProcedure(procedure) },
            React.createElement("div", { className: "procedure-icon" },
                React.createElement(Codepen, null)),
            React.createElement("div", { className: "procedure-content" },
                React.createElement("h3", null, lang.standardProcedureTitles[procedure.procedureId] ||
                    procedure.title),
                React.createElement("p", null, lang.standardProcedureDescriptions[procedure.procedureId] ||
                    procedure.description)),
            proceduresRunning[procedure.procedureId] && (React.createElement(PlaceholderLoader, { style: {
                    position: 'absolute',
                    zIndex: '-1',
                }, height: "100px" }))))))));
};
export default Procedures;
//# sourceMappingURL=Procedures.js.map